import { render, staticRenderFns } from "./ClickAndBuyTitleForm.vue?vue&type=template&id=a361a952&scoped=true"
import script from "./ClickAndBuyTitleForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyTitleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a361a952",
  null
  
)

export default component.exports